"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const Loading = ({ overlay = false }) => {
    if (overlay) {
        return (react_1.default.createElement("div", { style: {
                position: "fixed", // or 'absolute' if you want it relative to a container
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white
                zIndex: 2000, // Ensure it covers other content
            } },
            react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
                react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))));
    }
    return (react_1.default.createElement("div", { style: { padding: "20px" } },
        react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
            react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))));
};
exports.Loading = Loading;
